import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ConciliacaoBancariaTed } from '../domain/conciliacao-bancaria-ted.model';

export class ConciliacaoBancariaTedSerializer extends DomainSerializer<ConciliacaoBancariaTed> {}
